
export const getImage = (name, type) => {
    if(type) {
        switch (type) {
            case "docpass":
                return `/assets/img/docpass/${name}`
            default:
                return `/assets/img/${name}`;
        }
    } else {
        let localType = sessionStorage.getItem("layout")
        switch (localType) {
            case "docpass":
                return `/assets/img/docpass/${name}`
            default:
                return `/assets/img/${name}`;
        }
    }
}